import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_PREFIX, BASE_URL } from '@CONSTANTS/API.constant';
import userRepository from '@REPOSITORIES/local-repository/user-repository';

type RegionsApiResponse = {
    id: number;
    name: string;
};

export const regionApi = createApi({
    reducerPath: 'region-api',
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL + API_PREFIX,
        prepareHeaders: (headers) => {
            const token = userRepository.getData();

            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        getAll: builder.query<RegionsApiResponse[], void>({
            query: () => ({
                url: '/regions/',
            }),
            transformResponse: (raw: RegionsApiResponse[]) => raw.sort((a, b) => (a.name > b.name ? 1 : -1)),
        }),
    }),
});

export default regionApi;
